var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c("crud-button", {
        attrs: {
          large: "",
          color: "green",
          icon: "fa-file-import",
          tooltip: _vm.$t("global.crud.buttons.import")
        },
        on: {
          clicked: function($event) {
            return _vm.openFileUpload()
          }
        }
      }),
      _c("input", {
        ref: "file",
        attrs: { type: "file", id: "fileUpload", accept: ".xls,.xlsx" },
        on: {
          change: function($event) {
            return _vm.doImport()
          }
        }
      }),
      _c(
        "v-snackbar",
        {
          attrs: { top: true, right: true, color: "blue", timeout: 2000 },
          model: {
            value: _vm.importOK,
            callback: function($$v) {
              _vm.importOK = $$v
            },
            expression: "importOK"
          }
        },
        [_vm._v(" " + _vm._s(_vm.$t("import.ok")) + " ")]
      ),
      _c(
        "v-dialog",
        {
          attrs: { "hide-overlay": "", persistent: "", width: "300" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { color: "blue", dark: "" } },
            [
              _c(
                "v-card-text",
                [
                  _vm._v(" " + _vm._s(_vm.$t("import.loading")) + " "),
                  _c("v-progress-linear", {
                    staticClass: "mb-0",
                    attrs: { indeterminate: "", color: "white" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }